import { localeStore } from 'src/mobx/localesStore';
import './style.scss';

export interface IButtonSwitcherOption {
  label: string;
  key: string | number;
  className?: string;
}

interface IProps {
  className?: string;
  buttonClassName?: string;
  onClick: (option: IButtonSwitcherOption) => void;
  options: IButtonSwitcherOption[];
  selected: IButtonSwitcherOption['key'];
}

const ButtonSwitcher = (props: IProps): JSX.Element => {
  const getButtonClassName = (option: IButtonSwitcherOption) => {
    let _className = 'btn-switcher';

    if (props.buttonClassName) _className += ` ${props.buttonClassName}`;
    if (option.className) _className += ` ${option.className}`;
    if (props.selected === option.key) _className += ' btn-switcher-active';

    return _className;
  };

  return (
    <div className={`btn-switcher__wrapper ${props.className || ''}`} onClick={() => props.onClick}>
      {props.options.map((option) => (
        <button type="button" key={option.key} className={getButtonClassName(option)} onClick={() => props.onClick(option)}>
          {localeStore.t(option.label)}
        </button>
      ))}
    </div>
  );
};

export default ButtonSwitcher;
